import deepmerge from 'deepmerge'

import { AppConfig } from '../app-config'
import developmentConfig from './development'

const stagingConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://staging-api.databiologics.com/',
  authHost: 'https://staging-auth.databiologics.com/',
  tableauProductionBaseUrl: 'https://tableau.databiologics.com/',
  tableauProductionEmbeddedApiUrl:
    'https://tableau.databiologics.com/javascripts/api/tableau.embedding.3.latest.min.js',
  sentryDSN:
    'https://65ac2dc4bfb4f69f00bf935e9aea031a@o4510903226531840.ingest.us.sentry.io/4510975829737472',
  cdnPath: 'https://staging-cdn.databiologics.com',
})

export default stagingConfig
